<div class="dialog">
  <div class="dialog-header">
    <span class="dialog-title">
      Guests — Booking #{{ data.bookingId }}
    </span>

    <button type="button" class="close-btn" (click)="close()" aria-label="Close">
      ×
    </button>
  </div>

  <span class="dialog-subtitle">
    Family code {{ data.familyCode || '-' }}
  </span>

  @if(!data.guests || data.guests.length === 0){
  <div class="muted">No guest details recorded for this booking.</div>
  } @else {
  <div class="guest-list">
    @for(guest of data.guests; track $index){
    <div class="guest-line">
      <span class="guest-name">{{ guest.fullName || '-' }}</span>
      <span class="guest-aadhaar">Aadhaar: {{ guest.aadhaarNumber || '-' }}</span>
      <span class="guest-meta">
        {{ guest.guestType || '-' }}
        @if(guest.gender){ · {{ guest.gender }} }
        @if(guest.relationship){ · {{ guest.relationship }} }
      </span>
    </div>
    }
  </div>
  }
</div>
